var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"userHYl"}},[_vm._v("我是第一个chart")])}
var staticRenderFns = []

export { render, staticRenderFns }